<template>
    <div class="m-form-radio">
        <input type="radio" :id="`${name}_${value}`" :name="name" class="m-form-radio-input" :value="value" v-model="inputValue" @change=updateValue(inputValue) :data-jest="`form-radio-input-${name}-${value}`">
        <label :for="`${name}_${value}`" class="m-form-radio-label" data-jest="form-radio-label">{{ label }}</label>
    </div>
</template>

<script>
    export default {
        name: "FormRadio",
        data() {
            return {
                inputValue: "",
            }
        },
        props: {
            /**
             * value
             */
            value: {
                type: String,
                required: true
            },
            /**
             * label
             */
            label: {
                type: String,
                required: true
            },
            /**
             * name属性
             */
            name: {
                type: String,
                required: true
            },
            /**
             * 初期値
             */
            isDefaultChecked: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        emits: ['input'],
        created(){
            if(this.isDefaultChecked) {
                this.inputValue = this.value
                this.updateValue(this.inputValue)
            }
        },
        methods: {
            updateValue: function(value) {
                this.$emit("input", value);
            }
        },
        watch: {
            isDefaultChecked() {
                if(this.isDefaultChecked) {
                    this.inputValue = this.value
                }
            }
        }
    }
</script>
